import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { ErrorLink } from '@apollo/client/link/error';
import { from, switchMap } from 'rxjs';

import { getRefreshToken } from '../../amplify/getRefreshToken';

export const errorLink = new ErrorLink(({ error, operation, forward }) => {
  if (CombinedGraphQLErrors.is(error)) {
    for (const err of error.errors) {
      if (err.extensions?.code === 'invalid-jwt') {
        const oldHeaders = operation.getContext().headers;

        return from(getRefreshToken()).pipe(
          switchMap((token) => {
            operation.setContext({
              headers: {
                ...oldHeaders,
                authorization: token,
              },
            });
            return forward(operation);
          })
        );
      }

      console.log(
        `[GraphQL error] ${operation.operationName}: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`
      );
    }
  } else {
    console.log('[Network error]: ', error);
  }
});
